import * as baja from "@nwebui/bajascript";

import PxDecoder from "./PxDecoder";

// eslint-disable-next-line import/prefer-default-export
export async function loadPx(url: string): Promise<baja.Component> {
  const resp = await fetch(url);
  const text = await resp.text();
  const parser = new DOMParser();
  const xml = parser.parseFromString(text, "text/xml");
  const decoder = new PxDecoder(xml);
  return decoder.decodeDocument();
}
